import { Outlet, createBrowserRouter } from 'react-router'

import { AppShell } from '@/components/layout/app-shell'
import { RedirectIfAuthenticated, RequireAuth } from '@/routes/guards'

export const router = createBrowserRouter([
  {
    element: (
      <RedirectIfAuthenticated>
        <Outlet />
      </RedirectIfAuthenticated>
    ),
    children: [
      {
        path: '/login',
        lazy: async () => ({ Component: (await import('@/routes/login')).default }),
      },
    ],
  },
  {
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        lazy: async () => ({ Component: (await import('@/routes/dashboard')).default }),
      },
      {
        path: '/users',
        lazy: async () => ({ Component: (await import('@/routes/users')).default }),
      },
      {
        path: '/profile',
        lazy: async () => ({ Component: (await import('@/routes/profile')).default }),
      },
    ],
  },
  {
    path: '*',
    lazy: async () => ({ Component: (await import('@/routes/not-found')).default }),
  },
])
